module.exports = __webpack_public_path__ + "static/img/top2_i1_nav.91660a5a.png";